<script setup lang="ts">
import type { Order } from "@/schemas/order";

defineProps<{ order: Order }>();
</script>

<template>
  <div class="grid gap-8 lg:grid-cols-2">
    <div class="">
      <h2 class="h2 text-primary">
        Adresse de facturation
      </h2>
      <CustomerDetails :customer-details="order.customer.billing" />
    </div>
    <div class="">
      <h2 class="h2 text-primary">
        Adresse de livraison
      </h2>
      <CustomerDetails :customer-details="order.customer.shipping" />
    </div>
  </div>
</template>
